import { render, staticRenderFns } from "./MapaCatalunyaSectors.vue?vue&type=template&id=691c773a&scoped=true&"
import script from "./MapaCatalunyaSectors.vue?vue&type=script&lang=js&"
export * from "./MapaCatalunyaSectors.vue?vue&type=script&lang=js&"
import style0 from "./MapaCatalunyaSectors.vue?vue&type=style&index=0&id=691c773a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691c773a",
  null
  
)

export default component.exports